import React from 'react';
import { useLanguage } from '../../../context/LanguageContext';

export const ReferralTab = ({ referralCode, balance, transactions, triggerToast, discountPercent = 5, rewardPercent = 5, clicks = 0 }) => {
  const { t } = useLanguage();

  const referralLink = referralCode ? `${window.location.origin}/auth?ref=${referralCode}` : '';

  const handleCopyCode = async () => {
    if (!referralCode) return;
    try {
      await navigator.clipboard.writeText(referralCode);
      triggerToast(t('dashboard.referralCodeCopied') || t('dashboard.copied'), 'success');
    } catch (error) {
      triggerToast(t('dashboard.messages.copyKeyFailed'), 'error');
    }
  };

  const handleCopyLink = async () => {
    if (!referralLink) return;
    try {
      await navigator.clipboard.writeText(referralLink);
      triggerToast(t('dashboard.referralLinkCopied'), 'success');
    } catch (error) {
      triggerToast(t('dashboard.messages.copyKeyFailed'), 'error');
    }
  };

  return (
    <div>
      <div className="dash-title-block">
        <h2 className="dash-title">{t('dashboard.referralTitle')}</h2>
      </div>

      <p className="referral-tagline">{t('dashboard.referralTagline')}</p>

      <div className="main-dashboard-grid">
        <div className="cyber-panel">
          <div className="panel-header">
            <h3>{t('dashboard.referralCode')}</h3>
          </div>

          <div className="referral-code-box">
            <span className="referral-code-value">{referralCode}</span>
            <button className="cyber-action-btn" onClick={handleCopyCode}>
              <i className="fas fa-copy"></i> {t('dashboard.copyKey')}
            </button>
          </div>

          <div className="referral-link-box">
            <label>{t('dashboard.referralLinkLabel')}</label>
            <div className="referral-link-row">
              <span className="referral-link-value">{referralLink}</span>
              <button className="cyber-action-btn" onClick={handleCopyLink}>
                <i className="fas fa-link"></i> {t('dashboard.copyKey')}
              </button>
            </div>
            <p className="referral-link-hint">{t('dashboard.referralLinkHint')}</p>
          </div>

          <div className="referral-balance-box">
            <label>{t('dashboard.referralBalance')}</label>
            <span>{balance.toFixed(2)} $</span>
          </div>

          <div className="referral-balance-box">
            <label>{t('dashboard.referralClicks')}</label>
            <span>{clicks}</span>
          </div>
        </div>

        <div className="cyber-panel">
          <div className="panel-header">
            <h3>{t('dashboard.referralHowItWorks')}</h3>
          </div>
          <ul className="referral-steps">
            <li><i className="fas fa-check-circle"></i> {t('dashboard.referralStep1')}</li>
            <li><i className="fas fa-check-circle"></i> {t('dashboard.referralStep2Link')}</li>
            <li><i className="fas fa-check-circle"></i> {t('dashboard.referralStep3', { percent: discountPercent })}</li>
            <li><i className="fas fa-check-circle"></i> {t('dashboard.referralStep4', { percent: rewardPercent })}</li>
          </ul>
          <p className="referral-demo-note">{t('dashboard.referralDemoInfo', { percent: discountPercent })}</p>
        </div>
      </div>

      <div className="cyber-panel" style={{ marginTop: '24px' }}>
        <div className="panel-header">
          <h3>{t('dashboard.referralTransactions') || 'Referral transactions'}</h3>
        </div>
        {transactions.length > 0 ? (
          <div className="referral-transactions-list">
            {transactions.map((tx) => (
              <div key={tx.id} className="referral-transaction-item">
                <span>{tx.description || t('dashboard.referralEarning') || 'Earning'}</span>
                <span className="referral-earning">+{tx.amount.toFixed(2)} $</span>
              </div>
            ))}
          </div>
        ) : (
          <p className="referral-empty">{t('dashboard.referralNoTransactions') || 'No referral earnings yet.'}</p>
        )}
      </div>
    </div>
  );
};
